import { render } from "./SurveyQuestion.vue?vue&type=template&id=518ad2ab&scoped=true"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js"

import "./SurveyQuestion.vue?vue&type=style&index=0&id=518ad2ab&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518ad2ab"]])

export default __exports__